function downloadDialog () {
  return {
    restrict: 'E',
    templateUrl: '/arts/dialogs/download/download-dialog.html?$$REVISION$$'
  }
}
export { downloadDialog }
